import React from 'react';
import css from './FlipAndWinCards.css';
import FlipPostActionButton from './FlipPostActionButton';
import { cardAlreadyFlipped, cardLoss, cardWin, getCardWinContent } from './helpers';

export default ({ card, currentUser }) => {
    const { flipAndWinData } = currentUser?.attributes?.profile?.privateData || {};
    const { cardsFlipped } = flipAndWinData || { cardsFlipped: {} };

    if (!cardAlreadyFlipped(card, cardsFlipped)) return null;

    return (
        <div className={css.flipAndWinBackSide}>
            {cardWin(card, cardsFlipped) && (
                <>
                    <img
                        src="https://horsedeal.imgix.net/static/landingPageFlipAndWin/illustration-win.svg"
                        alt="loss-or-win-image"
                    />
                    <h4 className={css.cardSideHeading}>
                        Du hast <span className={css.prominent}>{getCardWinContent(card)}</span>{' '}
                        gewonnen!
                    </h4>
                    <FlipPostActionButton card={card} currentUser={currentUser} />
                </>
            )}
            {cardLoss(card, cardsFlipped) && (
                <>
                    <img
                        src="https://horsedeal.imgix.net/static/landingPageFlipAndWin/illustration-loss.svg"
                        alt="loss-or-win-image"
                    />
                    <h4 className={css.cardSideHeading}>
                        <span className={css.prominent}>Leider nichts!</span>
                        <br />
                        <span>Morgen?</span>
                    </h4>
                </>
            )}
        </div>
    );
};
